import * as React from "react";

import Container from "@mui/material/Container";

import CircularProgress from "components/circular-progress";

export const RouteSuspenseFallback: React.FC = () => (
  <Container>
    <CircularProgress />
  </Container>
);
